import React from "react";
import { Sparkles } from "lucide-react";

export function SmartTag({ onChange, changeLabel = "Change", testId = "smart-default-tag", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid={testId}>
      <span className="inline-flex items-center gap-1 rounded-full bg-brand-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-brand-700" title="Pre-filled for you. You can change it.">
        <Sparkles className="h-3 w-3" /> Smart default
      </span>
      {onChange && (
        <button type="button" onClick={onChange} className="text-[11px] font-semibold text-brand hover:underline" data-testid={`${testId}-change`}>{changeLabel}</button>
      )}
    </span>
  );
}

export function Chips({ options, value, onChange, testId, size = "sm" }) {
  const pad = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";
  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {options.map((o) => (
        <button key={o.id} type="button" onClick={() => onChange(o)} aria-pressed={value === o.id} className={`shrink-0 rounded-full font-medium transition-colors ${pad} ${value === o.id ? "bg-brand-100 text-brand-700 ring-1 ring-brand-200" : "bg-white text-ink-soft ring-1 ring-surface-300 hover:text-ink"}`} data-testid={`${testId}-${o.id}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
